import gql from 'graphql-tag';
import Interface from '../Interface';
import { UploadableType } from '../../enums/UploadableType';

export interface UploadParametersVars {
  contentType?: string;
  filename?: string;
  key: string;
  type: UploadableType;
}

interface UploadParametersData {
  getUploadParameters: { url: string };
}

export default class UploadParametersInterface extends Interface {
  public getUploadParameters(variables: UploadParametersVars) {
    return this.query<UploadParametersData>(
      () =>
        this.apolloService.executeQuery<UploadParametersData>({
          query: gql`
            query getUploadParameters(
              $type: UploadableTypeEnum!
              $key: String!
              $filename: String
              $contentType: String
            ) {
              getUploadParameters(
                type: $type
                key: $key
                filename: $filename
                contentType: $contentType
              ) {
                url
              }
            }
          `,
          variables,
        }),
      'Error loading parameters'
    ).then((data: UploadParametersData) => data.getUploadParameters);
  }
}
